import React, {useEffect, useState} from 'react';
import {Modal} from 'antd';
import {EmailPreview} from '../components/TicketGroup/View/EmailPreview';
import {EmailPreviewHeader} from '../components/TicketGroup/View/EmailPreviewHeader';
import {useEmailPreviewActions} from './emailPreview';
import {getClientMagicLink, getMagicLinkPreview} from '../queries/ticketGroup';
import {EmailPreviewT} from '../types/tickets';

export const useClientShare = (email?: string, groupId?: number, brand?: string) => {
  const [magicLink, setMagicLink] = useState<string | undefined>();
  const [emailPreview, setEmailPreview] = useState<EmailPreviewT | undefined>();

  const fetchMagicLink = async () => {
    setMagicLink('');
    if (!email) return;
    try {
      const res = await getClientMagicLink({
        body: {
          email,
          portal: 'groupTicket',
          ...(brand && {brand}),
        },
      });
      setMagicLink(res.body?.magicLink);
    } catch (error) {
      console.error('fetch magic link error: ', error);
    }
  };

  const fetchMagicLinkPreview = async () => {
    setEmailPreview(undefined);
    if (!groupId && groupId !== 0) return;
    try {
      const res = await getMagicLinkPreview(String(groupId));
      const preview = res?.body as EmailPreviewT;
      setEmailPreview(preview);
    } catch (error) {
      console.error('fetch email preview error: ', error);
    }
  };

  const openModal = () => {
    if (!emailPreview) return;

    // Create a component that uses the hook
    const HeaderWithActions = () => {
      const {handleCopyEmail, handleSavePDF} = useEmailPreviewActions(emailPreview);
      return <EmailPreviewHeader onCopyEmail={handleCopyEmail} onSavePDF={handleSavePDF} />;
    };

    Modal.info({
      title: <HeaderWithActions />,
      content: (
        <EmailPreview
          emailBody={emailPreview?.emailBody}
          subject={emailPreview?.subject}
          from={emailPreview?.from}
          to={emailPreview?.to}
        />
      ),
      okButtonProps: {
        style: {
          display: 'none',
        },
      },
      closable: true,
      className: 'preview',
    });
  };

  useEffect(() => {
    fetchMagicLink();
    fetchMagicLinkPreview();
  }, [email, brand]);

  return {magicLink, openModal};
};
